import { createActionFactory, Feature } from '../../../shared';
import type { Dispatch } from 'redux';

export const addFavoritePickerButtonClickedAction = createActionFactory<{}>(
    'AddFavoritePickerButtonClickedAction',
    Feature.FavoritePicker
);

export const addFavoritePickerButtonClicked = (dispatch: Dispatch) => () => {
    dispatch(addFavoritePickerButtonClickedAction());
};

export const favoritePickerDismissedAction = createActionFactory<{}>(
    'FavoritePickerDismissedAction',
    Feature.FavoritePicker
);

export const favoritePickerDismissed = (dispatch: Dispatch) => () => {
    dispatch(favoritePickerDismissedAction());
};
export type { Action } from '../../../shared';
